import { createBaseQuery } from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";
import { TransactionService } from "./tx-service";

export const txApis = createApi({
  reducerPath: "txApis",
  baseQuery: createBaseQuery(""),
  tagTypes: ["txApi"],
  endpoints: (build) => ({
    getTransactionLists: build.query<TxReportingData[], TransactionListParams>({
      query: ({ companyId, serviceId, data }) => ({
        url: TransactionService.getEndpointUrl({ companyId, serviceId }),
        method: "POST",
        body: data,
      }),
    }),
    getSingleTxBySystemRef: build.query<
      TxReportingData,
      SingleTransactionParams
    >({
      query: ({ companyId, serviceId, systemRef }) => ({
        url: TransactionService.getEndpointUrl(
          { companyId, serviceId },
          `/${systemRef}/details`
        ),
        method: "GET",
      }),
    }),
    getAggTxReport: build.query<
      TransactionAggregationData[],
      TxAggregationParams
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: TransactionService.getEndpointUrl(
          { companyId, serviceId },
          "/agg"
        ),
        method: "POST",
        body: data,
      }),
    }),
    getDailyAggReport: build.query<
      DailyTransactionAggregationData[],
      TxAggregationParams
    >({
      query: ({ companyId, serviceId, data }) => ({
        url: TransactionService.getEndpointUrl(
          { companyId, serviceId },
          "/daily-agg"
        ),
        method: "POST",
        body: data,
      }),
    }),
  }),
});
